import React from 'react';

import type { ISVGElement } from 'components/icons/types';

export const ClockIcon = (props: ISVGElement) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00016 2.35889C4.88471 2.35889 2.35914 4.88447 2.35914 7.99992C2.35914 11.1154 4.88471 13.6409 8.00016 13.6409C11.1156 13.6409 13.6412 11.1154 13.6412 7.99992C13.6412 4.88447 11.1156 2.35889 8.00016 2.35889ZM1.3335 7.99992C1.3335 4.31802 4.31826 1.33325 8.00016 1.33325C11.6821 1.33325 14.6668 4.31802 14.6668 7.99992C14.6668 11.6818 11.6821 14.6666 8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99992Z"
      fill="#68717B" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00019 4.06829C8.28341 4.06829 8.51301 4.29789 8.51301 4.58112V7.99992C8.51301 8.13593 8.45898 8.26637 8.36281 8.36254L6.31151 10.4138C6.11124 10.6141 5.78654 10.6141 5.58628 10.4138C5.38601 10.2135 5.38601 9.88885 5.58628 9.68858L7.48737 7.7875V4.58112C7.48737 4.29789 7.71697 4.06829 8.00019 4.06829Z"
      fill="#68717B" />
  </svg>
);
